import React, { useState } from "react";
import { TextField, Button } from "@mui/material";
import { fetchAllProducts } from "../util/firebaseUtils";

function SearchBar({ onSearch }) {

  const [searchField, setSearchField] = useState([]);

  // handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // fetch products from firestore
    const products = await fetchAllProducts();

    const filteredProducts = products.filter((product) => {
      if(searchField.length === 0) return true;
      return product.name.toLowerCase().includes(searchField.toLowerCase());
    });

    // pass products back to the parent
    onSearch(filteredProducts);
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        label="Product Name"
        variant="outlined"
        fullWidth
        margin="normal"
        onChange={(e) => setSearchField(e.target.value)}
        />
      <Button type="submit" variant="outlined" color="primary">
        Search
      </Button>
    </form>
  );
}

export default SearchBar;